import React, { useEffect, useRef } from 'react'
import MenuPopover from '@Components/Tooltips/MenuPopover'
import { PlacesType } from 'react-tooltip'

interface MlcPopoverMenuProps {
    clickableComponent: React.ReactNode
    menuComponent: React.ReactNode
    closeMenu: () => void
    classNames: string
    dataTooltipId: string
    dataTestId: string
    handleClick: () => void
    popoverOpen: boolean
    title?: string
    place?: PlacesType
}

const MlcPopoverMenu = (props: MlcPopoverMenuProps) => {
    const ref = useRef<HTMLDivElement>(null)

    const {
        clickableComponent,
        menuComponent,
        closeMenu,
        classNames,
        dataTooltipId,
        handleClick,
        popoverOpen,
        dataTestId,
        title,
        place,
    } = props

    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (ref.current && !ref.current.contains(event.target)) {
                closeMenu()
            }
        }
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    }, [closeMenu])

    return (
        <>
            <div
                className={classNames}
                data-testid={dataTestId}
                title={title}
                data-tooltip-id={dataTooltipId}
                onClick={handleClick}
                ref={ref}
            >
                {clickableComponent}
            </div>
            <MenuPopover menuId={dataTooltipId} isOpen={popoverOpen} place={place}>
                {menuComponent}
            </MenuPopover>
        </>
    )
}

export default MlcPopoverMenu
